module.exports = __webpack_public_path__ + "img/tertiary_1x4_z16.575fbbc5.svg";